const NAME = "RELATED_TABLES_DEFINITION";

export default NAME;
